<template>
  <a class="detail-icon pinterest-link" :href="href()" target="_blank" rel="noopener">
    <svg><use xlink:href="#pinterest"></use></svg>
  </a>
</template>

<style scoped>
</style>

<script>
export default {
    props: {
        url: {
            type: String,
            default: ''
        },
        imageUrl: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
    },

    methods: {
        href: function () {
            return 'https://www.pinterest.com/pin/create/button/?url=' + encodeURIComponent(this.url) +
                '&media=' +  encodeURIComponent(this.imageUrl) +
                '&description=' + encodeURIComponent(this.description)
        }
    },
}
</script>
